import { render, staticRenderFns } from "./reservationDetailModal.vue?vue&type=template&id=23df1bdf&scoped=true&"
import script from "./reservationDetailModal.vue?vue&type=script&lang=ts&"
export * from "./reservationDetailModal.vue?vue&type=script&lang=ts&"
import style0 from "./reservationDetailModal.vue?vue&type=style&index=0&id=23df1bdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23df1bdf",
  null
  
)

export default component.exports